<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item,index)  in levelList" :key="item.path" v-if="item.meta.title">
        <span v-if="item.redirect==='noredirect'||index==levelList.length-1" class="no-redirect"><template v-if="(userId == 653 || userId == 1016 || userId == 2990) && item.meta.title == 'CPA广告'">非标广告</template>
            <template v-else>{{item.meta.title}}</template></span>
        <router-link v-else :to="item.redirect||item.path">
            <template v-if="(userId == 653 || userId == 1016 || userId == 2990) && item.meta.title == 'CPA广告'">非标广告</template>
            <template v-else>{{item.meta.title}}</template>
        </router-link>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
    import { getToken } from '@/utils/auth'
    export default {
      created() {
        this.getBreadcrumb()
      },
      data() {
        return {
          levelList: null,
          userId: JSON.parse(getToken()).userId
        }
      },
      watch: {
        $route() {
          this.getBreadcrumb()
        }
      },
      methods: {
        getBreadcrumb() {
          let matched = this.$route.matched.filter(item => item.name)
          const first = matched[0]
          if (first && first.name !== '首页') {
            matched = [{ path: '/admanage', meta: { title: '首页' }}].concat(matched)
          }
          this.levelList = matched
        }
      }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .app-breadcrumb.el-breadcrumb {
    display: inline-block;
    font-size: 14px;
    line-height: 50px;
    margin-left: 10px;
    .no-redirect {
      color: #97a8be;
      cursor: text;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb/index.vue